import { useEffect, useState } from "react";
import { useKmsService } from "../providers/kms-service-provider";
import { ServiceCourse } from "../types/models/service-course";
import { resolveMinimalPriorite } from "../utils/minimal-service";

/**
 * Priorité du service minimal dû à un passager : le sien, sinon celui de
 * l'entreprise `idEntreprise`, sinon Standard.
 *
 * La fiche de l'entreprise ne porte que l'id de son service minimal : la
 * priorité se retrouve dans `servicesList`. La fiche reste ouverte à tout
 * utilisateur connecté, et couvre n'importe quelle entreprise (pas seulement
 * l'entreprise active, dont `/account/me` porte aussi l'id).
 */
export const useMinimalPriorite = (
  idEntreprise: number | null | undefined,
  serviceDuPassager: Pick<ServiceCourse, "priorite"> | null | undefined,
  servicesList: ServiceCourse[],
) => {
  const { entrepriseService } = useKmsService();

  // On garde l'entreprise avec son service : celui d'une entreprise quittée ne doit jamais
  // s'appliquer à la suivante le temps que sa fiche arrive.
  const [charge, setCharge] = useState<{
    idEntreprise: number;
    idMinimalService: number | null;
  } | null>(null);

  useEffect(() => {
    if (!idEntreprise) return;

    entrepriseService
      .getEntrepriseById(idEntreprise)
      .then((entreprise) =>
        setCharge({ idEntreprise, idMinimalService: entreprise.idMinimalService }),
      )
      .catch(() => setCharge({ idEntreprise, idMinimalService: null }));
  }, [idEntreprise, entrepriseService]);

  const idServiceEntreprise =
    idEntreprise && charge?.idEntreprise === idEntreprise
      ? charge.idMinimalService
      : null;

  return resolveMinimalPriorite(
    serviceDuPassager,
    servicesList.find((service) => service.id === idServiceEntreprise),
  );
};
